'use client';
import {
  KeyEventsByPath,
  keyEventsByPath,
} from '@storefront/services/DataCollection/types';
import {
  TRIGGERED_EVENTS_KEY,
  VALIDATION_STATUS_KEY,
  validateAnalyticsBatch,
  SESSION_STATUS_KEY,
} from '@storefront/services/DataCollection/validateSDEventsByPage';
import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

const WAIT_FOR_IN_MS = 3000;

const pageKeys = Object.keys(keyEventsByPath); // [/pdp-config/, /cart/, /checkout, /order/]

export const AnalyticsValidator = ({
  isDowntime,
}: {
  isDowntime: boolean;
}): any => {
  const session = useSession();

  useEffect(() => {
    const page = window.location.pathname;
    const pageKey = pageKeys.find((key) => page.includes(key));

    const events = JSON.parse(
      localStorage.getItem(TRIGGERED_EVENTS_KEY) || '{}'
    ) as KeyEventsByPath;

    const validationStatus = JSON.parse(
      localStorage.getItem(VALIDATION_STATUS_KEY) || '{}'
    ) as Record<string, any>;

    const pageIndex = pageKeys.indexOf(pageKey);

    // delete events and validation statuses from the current step to the last
    if (pageIndex > 0) {
      for (let i = pageIndex; i < pageKeys.length; i++) {
        const key = pageKeys[i];
        delete events[key];
        delete validationStatus[key];
      }
    }

    localStorage.setItem(TRIGGERED_EVENTS_KEY, JSON.stringify(events));
    localStorage.setItem(
      VALIDATION_STATUS_KEY,
      JSON.stringify(validationStatus)
    );

    const interval = setInterval(
      () => validateAnalyticsBatch(isDowntime),
      WAIT_FOR_IN_MS
    );
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    sessionStorage.setItem(SESSION_STATUS_KEY, session.status);
  }, [session.status]);

  return null;
};
